import React, { useState } from 'react';
import { Container, ExpandableSection, SpaceBetween, Header, Box } from '@amzn/awsui-components-core';

export const DisclaimerContainer: React.FC = () => {
  const [isDisclaimerExpanded, setIsDisclaimerExpanded] = useState(true);
  const [isDataSourcesExpanded, setIsDataSourcesExpanded] = useState(true);
  const [isBetaStatusExpanded, setIsBetaStatusExpanded] = useState(true);
  const [isHumanReviewExpanded, setIsHumanReviewExpanded] = useState(true);

  return (
    <Container
      header={
        <Header variant="h2">
          <span style={{ fontStyle: 'italic' }}>AI-Generated Content: Scope, Sources, and Caveats</span>
        </Header>
      }
    >
      <Box fontSize="body-s">
        <SpaceBetween size="m">
          <ExpandableSection
            headerText="Data Usage Disclaimer"
            expanded={isDisclaimerExpanded}
            onChange={() => setIsDisclaimerExpanded(!isDisclaimerExpanded)}
          >
            <p>
              This tool uses generative AI to create "baseball card" style summaries intended to support employee talent reviews for a technical
              audience. The outputs are informational only and should not be treated as authoritative, complete, or a substitute for manager judgment
              or formal performance evaluations.
            </p>
          </ExpandableSection>

          <ExpandableSection
            headerText="Data Sources & Coverage"
            expanded={isDataSourcesExpanded}
            onChange={() => setIsDataSourcesExpanded(!isDataSourcesExpanded)}
          >
            <p>The information presented is generated from a limited set of internal sources, including:</p>
            <br />
            <ul>
              <li>• Employee profile and job history from People API and Data Central Job History Summary</li>
              <li>
                • Primary ownership, role summaries, and justifications derived from Code Commits, SIM tickets, COE Tool, FinSuite Metrics, and
                Kingpin
              </li>
            </ul>
            <br />
            <p>
              Because inputs are intentionally scoped, outputs may be incomplete, outdated, or biased toward technical artifacts and may not fully
              reflect an individual's impact, scope, or contributions especially for non-technical roles.
            </p>
          </ExpandableSection>

          <ExpandableSection headerText="Beta Status" expanded={isBetaStatusExpanded} onChange={() => setIsBetaStatusExpanded(!isBetaStatusExpanded)}>
            <p>
              This tool is currently in beta. The models, prompts, and data mappings are actively evolving, and results may vary in accuracy and
              consistency. We are explicitly seeking feedback to improve:
            </p>
            <br />
            <ul>
              <li>• Signal quality for non-technical roles</li>
              <li>• Balance across qualitative and quantitative contributions</li>
              <li>• Overall clarity, fairness, and usefulness</li>
            </ul>
          </ExpandableSection>

          <ExpandableSection
            headerText="Human Review Required"
            expanded={isHumanReviewExpanded}
            onChange={() => setIsHumanReviewExpanded(!isHumanReviewExpanded)}
          >
            <p>
              All generated content should be reviewed, validated, and contextualized by humans before being used in decision-making, documentation,
              or downstream processes.
            </p>
            <p>
              <strong>By using this tool, you acknowledge these limitations and agree to provide feedback to help improve future iterations.</strong>
            </p>
          </ExpandableSection>
        </SpaceBetween>
      </Box>
    </Container>
  );
};
